import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Checkbox, FormControlLabel, Tooltip } from '@material-ui/core';
import { setCreateJiraTicket } from '../../../redux/actions/assetsAction';
import { isEmpty } from 'lodash';
import { useState } from 'react';

//constants
const label = 'Create Jira Ticket(s)';
const tooltipMsg = 'If enabled, A Jira ticket will be created for all assets in this collection.';
const disabledToolTip = 'one of the asset(s) do not have product linked';
// Check if there is an asset with no product linked.
const HasAssetWithNoProduct = (assets) => {
	return assets.some((asset) => isEmpty(asset.product));
};

// Create JIRA ticket checkbox component.
const CreateJiraTicket = () => {
	const dispatch = useDispatch();
	let isChecked = useSelector((state) => state.shouldCreateJiraTicket);
	const assets = useSelector((state) => state.assets);
	const [disableJira, setDisableJira] = useState(false);
	// Create JIRA ticket checkbox should be checked for Upload CSV view and should be unchecked for Manual Entry view.
	React.useEffect(() => {
		if (HasAssetWithNoProduct(assets)) {
			setDisableJira(true);
			/* 
			if there is at least one asset with no product linked, create JIRA checkbox should be disabled.
			since product is required for creating a JIRA ticket.
			*/
			// only set Create JIRA checkbox state false if it is already true. to avoid infinite re-rendering.
			if (isChecked !== false) {
				dispatch(setCreateJiraTicket(false));
			}
		} else {
			setDisableJira(false);
		}
	}, [assets, isChecked, dispatch]);
	const handleCheckboxOnChange = (event) => {
		dispatch(setCreateJiraTicket(event.target.checked));
	};
	return (
		<Tooltip title={disableJira ? disabledToolTip : tooltipMsg} arrow={true} placement="top">
			<FormControlLabel
				disabled={disableJira}
				control={
					<Checkbox
						checked={isChecked}
						onChange={(event) => handleCheckboxOnChange(event)}
						color="primary"
						inputProps={{ 'aria-label': 'secondary checkbox' }}
					/>
				}
				label={label}
			/>
		</Tooltip>
	);
};

export default CreateJiraTicket;
